import '@mui/lab/themeAugmentation';
import { createTheme as createMuiTheme } from '@mui/material/styles';
import variants from './variants.constant';
import typography from './typography.constant';
import breakpoints from './breakpoints.constant';
import components from './components.constant';
import shadows from './shadows.constant';

const createTheme = (name: string) => {
  let themeConfig = variants.find((variant) => variant.name === name);

  if (!themeConfig) {
    console.warn(new Error(`The theme ${name} is not valid`));
    themeConfig = variants[0];
  }

  return createMuiTheme(
    {
      spacing: 4,
      breakpoints: breakpoints,
      // @ts-ignore
      components: components,
      typography: typography,
      shadows: shadows,
      palette: themeConfig.palette,
    },
    {
      name: themeConfig.name,
      header: themeConfig.header,
      footer: themeConfig.footer,
      sidebar: themeConfig.sidebar,
    },
  );
};

export default createTheme;
